import React from 'react';
import { FormattedMessage } from 'react-intl';

import Heading from 'app/components/layout/Heading.styled';
import { Styled } from 'app/features/newLanding/components/HeroBlock/Perks/Perk.styled';
import Text from 'app/components/layout/Text.styled';

const OneHourAfterJapBroadcast = () => (
  <Styled.Perk data-t="one-hour-after-japan-broadcast-perk">
    <Styled.PerkIcon viewBox="0 0 40 40" color="scooter">
      <path d="M20 40a20 20 0 110-40 20 20 0 010 40zm0-2a18 18 0 100-36 18 18 0 000 36zm-5.75-12.66L19 20V9h2v11.38a1 1 0 01-.25.66l-5 5.62-1.5-1.32z" />
    </Styled.PerkIcon>
    <Heading as={Styled.PerkDescription} size="xxs">
      <FormattedMessage id="new_landing_one_hour_after_japan_broadcast_perk" />
    </Heading>
    <Text
      as={Styled.PerkDescriptionMobile}
      size="xl"
      type="semibold"
      isFixedSize
    >
      <FormattedMessage id="new_landing_one_hour_after_japan_broadcast_perk" />
    </Text>
  </Styled.Perk>
);

export default OneHourAfterJapBroadcast;
